import { Box, Card, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import DistributionGraphMockUp from 'modules/project_management/components/graphs/DistributionGraph'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from '../constants'

export const UpsellProjectsOverviewLanding = () => {
  return (
    <Box gap="s32">
      <Card>
        <Card.Content>
          <Text size="400" color="grey400" weight="semibold">
            {i18n.t('project_management.graphs.evolution.time.title')}
          </Text>
          <UpsellingKit.EmptyState
            moduleRequested={AvailableModules.projects}
            featureRequested={Features.projects_overview}
            requestReason={ValidReasons.MissingAddon}
            requestSource={ProjectsUpsellRequestSources.overview}
            title={i18n.t('project_management.upselling.title')}
            description={i18n.t('project_management.upselling.overview')}
            buttonLabel={i18n.t('project_management.upselling.cta')}
            variant="card"
          />
        </Card.Content>
      </Card>
      <Box width="full">
        <Card>
          <Card.Content>
            <Text size="400" color="grey400" weight="semibold">
              {i18n.t('project_management.overview.upgrade_plan.distribution_graph.title_table')}
            </Text>
            <Box
              width="full"
              height="full"
              paddingX="s32"
              paddingY="s64"
              flexDirection="column"
              gap="s16"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <DistributionGraphMockUp />
              <Box height="s400" width="full" />
              <Box
                flexDirection="columnReverse"
                maxHeight="s300"
                minHeight="s300"
                height="s400"
                width="full"
                minWidth="s300"
                maxWidth="full"
                background="lighter920"
                position="absolute"
                style={{
                  position: 'absolute',
                  opacity: '1',
                  filter: 'blur(50px)',
                }}
              />
            </Box>
          </Card.Content>
        </Card>
      </Box>
    </Box>
  )
}
